/**
 * NOTE: Background Service Refactoring idea:
 * - Service might be refactored with subcasses that inherit other Services
 * - The call than can be Background._LoginService.getToken()
 * - Inheritance can force implementation of all functions
 * - Message passing can be on a service level (Ex. sender = "Background_LoginService", message = "getToken")
 * - Implementation of whole can be separated both on Background.js (Service) and background.js (Service Worker)
 */
export class BackgroundService {
    static getTenants = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTenants",
                },
                (response) => {
                    // FIXME: LoginService.getAuth() returns null when auth is not present
                    //        this produces bug. `?` is added but refactor is needed
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getTenant = (tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTenant",
                    tenantId: tenantId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createTenant = (tenant) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createTenant",
                    tenant: tenant,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateTenant = (tenant) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateTenant",
                    tenant: tenant,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteTenant = (tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteTenant",
                    tenantId: tenantId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getTenantAuthorities = (tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTenantAuthorities",
                    tenantId: tenantId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createTenantAuthority = (tenantId, authority) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createTenantAuthority",
                    tenantId: tenantId,
                    authority: authority,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteTenantAuthority = (tenantId, authorityId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteTenantAuthority",
                    tenantId: tenantId,
                    authorityId: authorityId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getTenantTags = (tenantId, tagStart) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTenantTags",
                    tenantId: tenantId,
                    tagStart: tagStart,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createTenantTag = (tenantId, tag) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createTenantTag",
                    tenantId: tenantId,
                    tag: tag,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static renameTenantTag = (tenantId, tagId, newTagName) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "renameTenantTag",
                    tenantId: tenantId,
                    tagId: tagId,
                    newTagName: newTagName,
                },
                (response) => {
                    if (!response) {
                        resolve(response);
                        return;
                    }
                    if (!response.isError) resolve(response);
                    else reject(response);
                }
            );
        });
    };
    

    static deleteTenantTag = (tenantId, tagId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteTenantTag",
                    tenantId: tenantId,
                    tagId: tagId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getNumberOfSnippetsWithTag = (tenantId, tagId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getNumberOfSnippetsWithTag",
                    tenantId: tenantId,
                    tagId: tagId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateTenantSubscription = (tenantId, subscription) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateTenantSubscription",
                    tenantId: tenantId,
                    subscription: subscription,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getTenantCollaborators(tenantId) {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTenantCollaborators",
                    tenantId: tenantId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    }

    static createTopic = (topic) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createTopic",
                    topic: topic,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getTopic = (topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getTopic",
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateTopic = (topic) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateTopic",
                    topic: topic,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updatePublicRole = (publicRole, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updatePublicRole",
                    publicRole: publicRole,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteTopic = (topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteTopic",
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateReaction = async (snippetId, topicId, reaction) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateReaction",
                    snippetId: snippetId,
                    topicId: topicId,
                    reaction: reaction,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteReaction = async (snippetId, topicId, reactionId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteReaction",
                    snippetId: snippetId,
                    topicId: topicId,
                    reactionId: reactionId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createTopicRole = (topicId, topicRole) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createTopicRole",
                    topicId: topicId,
                    topicRole: topicRole,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateTopicRole = (topicId, topicRole) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateTopicRole",
                    topicId: topicId,
                    topicRole: topicRole,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteTopicRole = (topicId, topicRoleId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteTopicRole",
                    topicId: topicId,
                    topicRoleId: topicRoleId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getSnippets = (topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getSnippets",
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getSnippet = (snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getSnippet",
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };


    static getInboxSnippets = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getInboxSnippets",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createSnippet = (snippet, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createSnippet",
                    topicId: topicId,
                    snippet: snippet,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateSnippet = (snippet, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateSnippet",
                    topicId: topicId,
                    snippet: snippet,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static moveSnippetToInbox = (snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "moveSnippetToInbox",
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteSnippet = (snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteSnippet",
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static createComment = (comment, snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "createComment",
                    comment: comment,
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static updateComment = (comment, snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "updateComment",
                    comment: comment,
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static usernameExists = (username) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "usernameExists",
                    username: username,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getMyPersonalTenant = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getMyPersonalTenant",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static deleteComment(commentId, snippetId, topicId) {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "deleteComment",
                    commentId: commentId,
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    }

    static removeTagFromSnippet = (tagId, snippetId, topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "removeTagFromSnippet",
                    tagId: tagId,
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static refreshTokenLogin = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "refreshTokenLogin",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getAuth = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getAuth",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getCollaborators = (topicId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getCollaborators",
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getClusters = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getClusters",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static checkPDFExistence = (url) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "checkPDFExistence",
                    url: url,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static uploadPublicPDF = (file, source) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onloadend = function () {
                chrome.runtime.sendMessage(
                    {
                        from: "app",
                        subject: "uploadPublicPDF",
                        file: reader.result,
                        source: source,
                    },
                    (response) => {
                        if (!response.isError) resolve(response);
                        else reject(response);
                    },
                );
            };
            reader.readAsDataURL(file);
        });
    };

    static getSlackWorkspaces = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getSlackWorkspaces",
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static syncSlackWorkspace = (workspaceId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "syncSlackWorkspace",
                    workspaceId: workspaceId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static addTagToSnippetWithRetry(tag, snippetId, topicId) {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "addTagToSnippetWithRetry",
                    tag: tag,
                    snippetId: snippetId,
                    topicId: topicId,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    }

    static getSnippetSuggestions = (content) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getSnippetSuggestions",
                    content: content,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    }

    // Cache Service Methods
    static getEntity = (type, id, tenantId) => {
        return new Promise((resolve, reject) => {
            try {
                chrome.runtime.sendMessage(
                    {
                        from: "app",
                        subject: "getEntity",
                        type,
                        id,
                        tenantId,
                    },
                    (response) => {
                        if (chrome.runtime.lastError) {
                            console.error("Error in getEntity:", chrome.runtime.lastError);
                            reject(chrome.runtime.lastError);
                            return;
                        }
                        
                        if (!response?.isError) resolve(response);
                        else reject(response);
                    },
                );
            } catch (error) {
                console.error("Exception in getEntity:", error);
                reject(error);
            }
        });
    };

    static setEntity = (type, entity, tenantId) => {
        return new Promise((resolve, reject) => {
            try {
                chrome.runtime.sendMessage(
                    {
                        from: "app",
                        subject: "setEntity",
                        type,
                        entity,
                        tenantId,
                    },
                    (response) => {
                        if (chrome.runtime.lastError) {
                            console.error("Error in setEntity:", chrome.runtime.lastError);
                            reject(chrome.runtime.lastError);
                            return;
                        }
                        
                        if (!response?.isError) resolve(response);
                        else reject(response);
                    },
                );
            } catch (error) {
                console.error("Exception in setEntity:", error);
                reject(error);
            }
        });
    };

    static setEntities = (type, entities, tenantId) => {
        return new Promise((resolve, reject) => {
            try {
                chrome.runtime.sendMessage(
                    {
                        from: "app",
                        subject: "setEntities",
                        type,
                        entities,
                        tenantId,
                    },
                    (response) => {
                        if (chrome.runtime.lastError) {
                            console.error("Error in setEntities:", chrome.runtime.lastError);
                            reject(chrome.runtime.lastError);
                            return;
                        }
                        
                        if (!response?.isError) resolve(response);
                        else reject(response);
                    },
                );
            } catch (error) {
                console.error("Exception in setEntities:", error);
                reject(error);
            }
        });
    };

    static removeEntity = (type, id, tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "removeEntity",
                    type,
                    id,
                    tenantId,
                },
                (response) => {
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static clearEntityType = (type, tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "clearEntityType",
                    type,
                    tenantId,
                },
                (response) => {
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getAllEntities = (type, tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getAllEntities",
                    type,
                    tenantId,
                },
                (response) => {
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static clearAll = () => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "clearAll",
                },
                (response) => {
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static clearTenantData = (tenantId) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "clearTenantData",
                    tenantId,
                },
                (response) => {
                    if (!response?.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getKnowledgeTriggers = (pageUrl) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getKnowledgeTriggers",
                    pageUrl: pageUrl
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static getArchivedSnippets = (topicId, limit, offset) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "getArchivedSnippets",
                    topicId,
                    limit,
                    offset,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };

    static searchArchivedSnippets = (topicId, searchTerm, limit, offset) => {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(
                {
                    from: "app",
                    subject: "searchArchivedSnippets",
                    topicId,
                    searchTerm,
                    limit,
                    offset,
                },
                (response) => {
                    if (!response.isError) resolve(response);
                    else reject(response);
                },
            );
        });
    };
}
